var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1.6em",
    viewBox: "0 0 228 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 50C0 22.3858 22.3858 0 50 0H178C205.614 0 228 22.3858 228 50V178C228 205.614 205.614 228 178 228H50C22.3858 228 0 205.614 0 178V50Z",
    fill: "#FEDA03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.756 95.4469C171.756 106.384 165.366 111.824 158.185 113.714C166.78 116.29 173 123.334 173 134.5V155H140.202V135.531C140.202 129.575 136.696 127.17 130.702 127.17H91.7976V155H59V73H136.923C156.488 73 171.756 77.2374 171.756 95.4469ZM91.8122 95.9099H136.151V95.9135C136.217 95.9111 136.284 95.9099 136.35 95.9099C139.399 95.9099 141.871 98.4127 141.871 101.5C141.871 104.587 139.399 107.09 136.35 107.09C136.284 107.09 136.217 107.089 136.151 107.087V107.09H91.8122V95.9099Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRSymbol);
export default __webpack_public_path__ + "static/media/RSymbol.0e37f0a5d9da8b7d7950c810a432e421.svg";
export { ForwardRef as ReactComponent };